module.exports = __webpack_public_path__ + "media/images/page/lottery_sample_photo_middle-33b3e5c0291d776350bc7b1a1b475033.jpg";